/** @jsxImportSource @emotion/react */
import * as Inputs from "../common/hook-form/index";
import { css } from "@emotion/react";
import { colors } from "../../components/colors";
import {
  FieldArrayWithId,
  UseFieldArrayRemove,
  useFormContext,
} from "react-hook-form";
import { FormValues } from "./ProductAdditionsUpsert";
import { StyledText } from "../../assets/typography/typography";
import { CheckboxInput } from "../../components/forms/inputs/CheckboxInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { PriceInput } from "../../components/forms/inputs/PriceInput";

const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 4px;
  gap: 16px;
  border: 1px solid ${colors.greyBorder};
`;

const upperWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const outerFieldsWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const fieldsWrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: start;
`;

const xStyle = css`
  color: ${colors.textSecondary};
  cursor: pointer;
  &:hover {
    color: ${colors.textPrimary};
  }
`;

type Props = {
  field: FieldArrayWithId<FormValues, "products", "id">;
  remove: UseFieldArrayRemove;
  index: number;
};

export const ProductAddition = ({ field, remove, index }: Props) => {
  const methods = useFormContext<FormValues>();
  const {
    watch,
    register,
    formState: { errors },
  } = methods;
  const type = watch("type");

  return (
    <div css={wrapperStyle}>
      <div css={upperWrapperStyle}>
        <StyledText
          color={colors.textPrimary}
          className="bodyTextSemibold mb-0"
        >
          {field.name}
        </StyledText>
        <StyledText
          css={xStyle}
          className="bodyTextSemibold mb-0"
          onClick={() => remove(index)}
        >
          <FontAwesomeIcon icon={solid("x")} />
        </StyledText>
      </div>
      {type !== "single" && (
        <div css={outerFieldsWrapperStyle}>
          <div css={fieldsWrapperStyle}>
            <Inputs.InputFormField
              errors={errors}
              errorMessage={
                errors.products &&
                errors.products[index]?.maximumSelections?.message
              }
              register={register}
              type="number"
              label="Maximum selection"
              min={1}
              name={`products.${index}.maximumSelections` as any}
              helpText="Choose the maximum amount a user can choose for this addition."
            />
            <PriceInput
              formMethods={methods}
              label="Add-on price"
              name={`products.${index}.additionalSelectionPriceAmount` as any}
              currencyName={
                `products.${index}.additionalSelectionPriceCurrency` as any
              }
              helpertext="Add-on price determines what the second, third etc. costs. The first choice of the addition will follow the addition price."
            />
            {/* <Inputs.InputFormField
              errors={errors}
              errorMessage={
                errors.products &&
                errors.products[index]?.additionalSelectionPriceAmount?.message
              }
              type="number"
              register={register}
              label="Add-on price"
              name={`products.${index}.additionalSelectionPriceAmount` as any}
              helpText="Add-on price determines what the second, third etc. costs. The first choice of the addition will follow the addition price. Please note that the price should be written in full, including decimals. E.g. 10 kr. should be written as “1000”. 250 kr should be written as “25000” etc."
            /> */}
          </div>
        </div>
      )}
      <CheckboxInput
        label="Preselect addition"
        name={`products.${index}.isPreselected` as any}
      />
    </div>
  );
};
